var _rect, _circle, _circle2, _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacanciesFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 24,
    viewBox: "0 0 41 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 24,
    rx: 12,
    fill: "#343843"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10.5,
    r: 6,
    stroke: "#757A88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10.5,
    r: 4.5,
    fill: "#757A88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18.7891 10 19.4286 9.32852 19.4286 8.5C19.4286 7.67148 18.7891 7 18 7C17.2109 7 16.5714 7.67148 16.5714 8.5C16.5714 9.32852 17.2109 10 18 10ZM19 10.375H18.8136C18.5658 10.4945 18.2902 10.5625 18 10.5625C17.7098 10.5625 17.4353 10.4945 17.1864 10.375H17C16.1719 10.375 15.5 11.0805 15.5 11.95V12.4375C15.5 12.748 15.74 13 16.0357 13H19.9643C20.26 13 20.5 12.748 20.5 12.4375V11.95C20.5 11.0805 19.8281 10.375 19 10.375Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.2071,
    y1: 16,
    x2: 26.5,
    y2: 19.2929,
    stroke: "#757A88",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacanciesFilter);
export default __webpack_public_path__ + "static/media/vacancies_filter.1844425b29fb7619e3cc2d5cad0e932f.svg";
export { ForwardRef as ReactComponent };